module.exports = __webpack_public_path__ + "media/styles/images/svg/sliders-white-5a5e72371b7d41fadea3e02614e30a57.svg";